// "Bring your own product" link boxes (shared/_amazon_upload_box and the grid card
// shared/_link_box_card): store detection, paste-to-submit, and the submit button's loading
// state. The server still validates.
(function () {
  // Per store: its hosts, and the link shapes that carry a product id (every part of a shape
  // must match). Mirrors the server's parsers, Amazon.get_asin_from_link and
  // BestBuy::Product.find_by_link, which still have the final say.
  var STORES = {
    'Amazon': {
      host: /(^|\.)(amazon\.com|a\.co|amzn\.to)$/i,
      productLinks: [
        // /dp/B0015T963C, /gp/product/B0015T963C, /gp/aw/d/B0015T963C, /product-reviews/B0015T963C
        { path: /\/(?:dp|gp(?:\/[\w-]*){1,2}|product-reviews)\/\w{10}(?:\/|$)/ },
        // ?asin=B0015T963C
        { query: /[?&]asin=\w{10}(?:&|$)/i },
        // a.co/d/8Xj2kLm, amzn.to/3ABCDEF — resolved server-side (Amazon.clean_link)
        { host: /(^|\.)(a\.co|amzn\.to)$/i, path: /^\/(?:d\/)?[\w-]+\/?$/ }
      ]
    },
    'Best Buy': {
      host: /(^|\.)bestbuy\.com$/i,
      productLinks: [
        // /site/<slug>/6447382.p
        { path: /\/site\/(?:.*\/)?\d{5,8}\.p(?:\/|$)/ },
        // /site/…?skuId=6447382
        { path: /\/(?:site|product)\//, query: /[?&]skuId=\d+/i },
        // /product/<slug>/<code>
        { path: /\/product\/[a-z0-9][a-z0-9-]*(?:\/|$)/ }
      ]
    }
  };

  // Accepts share text around the link ("Check this out https://a.co/d/…") and bare domains.
  function parseUrl(text) {
    var match = text.match(/https?:\/\/\S+/i);
    var candidate = match ? match[0] : (/^[^\s/]+\.\S+$/.test(text) ? 'https://' + text : '');
    try { return candidate ? new URL(candidate) : null; } catch (e) { return null; }
  }

  function isProductLink(url, store) {
    return store.productLinks.some(function (shape) {
      return (!shape.host || shape.host.test(url.hostname)) &&
        (!shape.path || shape.path.test(url.pathname)) &&
        (!shape.query || shape.query.test(url.search));
    });
  }

  // { store, product } for a link on a known store (product is false for its search, category
  // and other non-product pages); null for anything else.
  function detectStore(text, stores) {
    var url = parseUrl(text);
    if (!url) return null;
    for (var i = 0; i < stores.length; i++) {
      var store = STORES[stores[i]];
      if (store.host.test(url.hostname)) return { store: stores[i], product: isProductLink(url, store) };
    }
    return null;
  }

  function init(box) {
    var form = box.querySelector('form');
    var input = form.querySelector('[data-link-box-input]');
    var status = form.querySelector('[data-link-box-status]');
    var submit = form.querySelector('[data-link-box-submit]');
    var label = submit.querySelector('[data-loading-text]');
    var stores = form.dataset.bestBuy === 'true' ? Object.keys(STORES) : ['Amazon'];
    var storeNames = stores.join(' or ');
    var defaultStatus = status.innerHTML;
    var detectedText = form.dataset.detectedText || '{store} link detected — press Enter or the arrow.';
    var idleLabel = label.textContent;
    var widePlaceholder = input.placeholder;
    var stackedBelow = Number(input.dataset.placeholderStackedBelow) || 600;

    function setStatus(html, tone) {
      status.innerHTML = html;
      status.classList.toggle('is-success', tone === 'success');
      status.classList.toggle('is-error', tone === 'error');
    }

    function refresh() {
      var value = input.value.trim();
      if (!value) { setStatus(defaultStatus); return false; }
      var link = detectStore(value, stores);
      if (link && link.product) { setStatus(detectedText.replace('{store}', link.store), 'success'); return true; }
      if (link) setStatus('That ' + link.store + " link isn't a product page — open the item and paste its link.", 'error');
      else setStatus("That doesn't look like a product link from " + storeNames + '.', 'error');
      return false;
    }

    function setLoading(loading) {
      form.classList.toggle('is-loading', loading);
      submit.disabled = loading;
      submit.setAttribute('aria-busy', loading);
      label.textContent = loading ? label.dataset.loadingText : idleLabel;
    }

    // the big box mirrors the @container (min-width: 600px) breakpoint in link_box.scss;
    // the grid card swaps where its full placeholder stops fitting
    function syncPlaceholder() {
      var wide = box.getBoundingClientRect().width >= stackedBelow;
      input.placeholder = wide ? widePlaceholder : input.dataset.placeholderStacked;
    }

    function submitForm() {
      if (form.requestSubmit) form.requestSubmit();
      else { setLoading(true); form.submit(); }
    }

    if (input.dataset.placeholderStacked) {
      syncPlaceholder();
      if (window.ResizeObserver) new ResizeObserver(syncPlaceholder).observe(box);
    }

    input.addEventListener('input', refresh);
    input.addEventListener('paste', function () {
      setTimeout(function () { if (refresh()) submitForm(); }, 0);
    });

    form.addEventListener('submit', function (event) {
      if (form.classList.contains('is-loading')) {
        event.preventDefault();
      } else if (!input.value.trim()) {
        event.preventDefault();
        setStatus('Paste a product link first.', 'error');
        input.focus();
      } else if (refresh()) {
        setLoading(true);
      } else {
        event.preventDefault();
        input.focus();
      }
    });

    var paste = form.querySelector('[data-link-box-paste]');
    if (paste) paste.addEventListener('click', function () {
      var clipboard = navigator.clipboard;
      if (!clipboard || !clipboard.readText) { input.focus(); return; }
      clipboard.readText().then(function (text) {
        input.value = text.trim();
        if (refresh()) submitForm(); else input.focus();
      }).catch(function () { input.focus(); });
    });

    // back/forward cache restores the page mid-"Finding product…"
    window.addEventListener('pageshow', function (event) { if (event.persisted) setLoading(false); });
  }

  // every box ships the pack tag, so a page with two boxes runs this file twice
  function ready() {
    document.querySelectorAll('[data-link-box]:not([data-link-box-ready])').forEach(function (box) {
      box.setAttribute('data-link-box-ready', '');
      init(box);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
